import { femaleRatioPerStrengthDescription, maleRatioPerStrengthDescription } from 'fitbeat.gym-core';
import {
  Gender,
  smallBodyGroupTypesArray,
  StrengthRatioForMuscleGroups,
} from 'fitbeat.models';
import i18n from './i18n';

const buildStrengthRatios = (ratio: number): StrengthRatioForMuscleGroups => {
  return smallBodyGroupTypesArray.reduce((acc, cur) => {
    acc[cur] = ratio;
    return acc;
  }, {}) as StrengthRatioForMuscleGroups;
};

export const getStrengthLevels = (gender: Gender) => {
  const ratios = gender === Gender.Male ? maleRatioPerStrengthDescription : femaleRatioPerStrengthDescription;
  return [
    {
      display: i18n.t('auth:belowAverageTitle'),
      subtitle: i18n.t('auth:belowAverageSubtitle'),
      value:  buildStrengthRatios(ratios.belowAverage),
    },
    {
      display: i18n.t('auth:averageTitle'),
      subtitle: i18n.t('auth:averageSubtitle'),
      value: buildStrengthRatios(ratios.average),
    },
    {
      display: i18n.t('auth:aboveAverageTitle'),
      subtitle: i18n.t('auth:aboveAverageSubtitle'),
      value: buildStrengthRatios(ratios.aboveAverage),
    },
    {
      display: i18n.t('auth:strengthAthleteTitle'),
      subtitle: i18n.t('auth:strengthAthleteSubtitle'),
      value: buildStrengthRatios(ratios.strengthAthlete),
    },
  ];
};
